<template>
    <div>
            <top-navbar></top-navbar>
    
    
            <div class="mb-5 background_color" >
              

                <h6 class="manage-boder pt-2 font1  decoration"> <router-link class="decoration" to="/">Home</router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" >Purchasing</a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/cgrn/index">Manage GRN</router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>Create GRN</h6>
                <!-- <h6 class="custom-maintitle mb-2"><b>Create Customer </b></h6> -->
<div style=" padding-bottom: 200px;" class="container-fluid">
  <div class="card bdr-rad2 mt-1 shadow p-2">
  <div  class="card-body custom_bdr_rds">


    <b-modal :id="infoModal2.id" 
     :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant"
      size="lg" hide-footer
     bottom>
    <template   #modal-title>
     
      <h5 >View Pending Quotations</h5>

      
  
    </template>
    
   <div>
    <table class="table table-sm table-info table-striped font-size_def">
          <thead>
              <tr>
                  <th style="width:10%">Quotation</th>
                  <th style="width:20%;">Dealer name</th>
                  <th style="width:20%;">Sales Person</th>
                  <th style="width:20%;">Qty</th>
                
               
                  
              </tr>                        
          </thead>
          <tbody id="">
            <tr v-for="conten in infoModal2.content" :key="conten.C_name">
              <td>{{ conten.qu_code  }}</td>
              <td>{{ conten.C_name }}</td>
              <td>{{ conten.name }}</td>
              <td>{{ conten.Qty }}</td>
            </tr>
            <tr>
              <th></th>
              <th>Total Available Qty</th>
              <th></th>
              <th>{{ qty }}</th>
            </tr>
               
          </tbody>
          </table>

   </div>

  

  
  </b-modal>


  <b-modal :id="infoModal1.id" 
     :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant"
      size="lg" hide-footer
     bottom>
    <template   #modal-title>
     
      <h5 >View Pending Quotations</h5>

      
  
    </template>
    
   <div>
    <table class="table table-sm table-info table-striped font-size_def">
          <thead>
              <tr>
                  <th style="width:10%">Quotation</th>
                  <th style="width:20%;">Dealer name</th>
                  <th style="width:20%;">Value</th>
                  <th style="width:20%;">Sales Person</th>
                
               
                  
              </tr>                        
          </thead>
          <tbody id="">
            <tr v-for="conten in infoModal1.content" :key="conten.C_name">
              <td>{{ conten.qu_code  }}</td>
              <td>{{ conten.C_name }}</td>
              <td>{{ conten.total }}</td>
              <td>{{ conten.name }}</td>
            </tr>
               
          </tbody>
          </table>

   </div>

  

  
  </b-modal>

   

                    <form @submit.prevent="SaveQuotation()" >


<div class="row">

    <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Received Date </label>
            <input type="date" v-model="squatation.received_date"   style="font-size: small;" class="form-control" required>
    </div>
  </div>
    <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Supplier</label>
            <v-select class="font-size_def" label="sup_name"  @input="supgrnLoad()"  v-model="squatation.G_idVendor"  :options="suppliers" :class="{'is-invalid': errors.idCustomerError}"></v-select>
            <div class="invalid-feedback">
              {{ errors.idCustomerError }}
            </div>
    </div>
  </div>

  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Purchase Order</label>
            <v-select class="font-size_def" label="p_code" @input="Grndataload()"  :options="allpo" v-model="squatation.grndata"
            ></v-select>
            <!-- <div class="invalid-feedback">
              {{ errors.customerContactError }}
            </div> -->
            <!-- :class="{'is-invalid': errors.customerContactError}" -->
    </div>
  </div>
  
 


  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Remarks</label>
            <textarea v-model="squatation.remarks" class="form-control" rows="2"></textarea>
    </div>
  </div>
</div>


















<div class="card custom_bdr_rds">
        <div class="card-body custom_bdr_rds">
    <h6 class="purchitem mb-2"><b>Purchased Items</b></h6>
    <div class="table-responsive mb-1">
      <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
        <thead class="background_color2">
            <tr class="custom-label2">
                <th>#</th>
                <th  >   
                  <div class="form-group custom-form required">
                    Product Code
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form ">
                     Product Description
                  </div>
                </th>
                <th >
                  <div class="form-group custom-form ">
                    BIN Location
                  </div>
                </th>
                <th >
                  <div class="form-group custom-form required">
                    Requested PO Qty
                    </div>
                </th>
                <th  >
                  <div class="form-group custom-form required">
                    Already GRN Qty
                  </div>
                </th>
                <th  >
                  <div class="form-group custom-form required">
                    Remaining PO Qty
                  </div>
                </th>
                <th  >
                  <div class="form-group custom-form required">
                    Unit Price (Rs.)
                  </div>
                </th>
                
                <th  >
                  <div class="form-group custom-form required">
                    Total (Rs.)
                  </div>
                </th>
                <th  >
                  <div class="form-group custom-form required">
                    This GRN Qty
                  </div>
                </th>
                <th  >
                  <div class="form-group custom-form required">
                    Unit Cost Price (Rs.)
                  </div>
                </th>
                <th  >
                  <div class="form-group custom-form required">
                    Total Cost Price (Rs.)
                  </div>
                </th>
                
               
                 
                
              
             
            </tr>
          </thead>
          <tbody>
            <tr  v-for="(dtl, index) in dtls" :key="dtl.id">
            <td>{{ index+1 }} <input v-model="dtl.id" type="hidden" /></td>
            <td>{{ dtl.P_code }}
             
            </td>
            <td>{{ dtl.P_description }}</td>
            <td >{{ dtl.bin_location }}</td>
            <td  class="text_right">{{ dtl.p_qty }}</td>
            <td  class="text_right">{{ dtl.grn_qty }}</td>
            <td  class="text_right">{{ dtl.remaining_qty }}</td>
            <td  class="text_right">{{ dtl.p_product_price }}</td>
            <td  class="text_right">{{ dtl.total_price }}</td>
            <td  ><input  class="form-control text-right" v-model="dtl.thisgrnqty"  @input="calgrn(index)" /></td>
            <td  ><input class="form-control text-right" v-model="dtl.unitcost" @input="calgrn(index)" /> </td>
            <td ><input class="form-control text-right" v-model="dtl.totalcostprice" /> </td>
          
              
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td class="text-right">Total</td>
              <td></td>
              <td></td>
              <td class="text-right">{{ total_cost }}</td>
            </tr>
          
           
            
           
           
           

     
          
            
          </tbody>


        </table>
       
    </div>
    </div>
    </div>
    

    <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
        <button  type="submit" class="mr-1 btn btn-outline-primary  mb-1 font-size_def bdr-rad">Create</button>
    </div>
    </div>
    <br><br>


</form>




                </div>
                </div>
              </div> 
            </div>
    
            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    
    </template>
    <script src="/js/vue-select/vue-select.js"> </script>
    <script type="text/javascript" src="https://cdnjs.cloudflare.com/ajax/libs/vue/1.0.13/vue.min.js"></script>
    <script>
      import vSelect from 'vue-select';
      import 'vue-select/dist/vue-select.css';
     import axios from 'axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'
     
    
    
      export default {

        mounted(){
    this.loadPo();
   // this.loadCustomer();
    this.loadSupplier();
      },
        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
            count: 0,
        total:0,
        selectedOption: null, // Store the selected option
        subtotal:"0.00",
        gpmrg_total:"0.00",
        gpMrgPre_total:"0.00",
        final_total:"0.00",
        total_cost:"0.00",
        qty:0,
        mcustomers:[],
        mproducts:[],
        contacts:[],
        allpo:[],
        details:[],
        suppliers:[],
        dtls:[],
      errors: {},
      lenthdtls: {},
     
      squatation:{},
        customer:{},
        quotation:{
          'validity_period':{
            label: 'Select Validity Period', value: ''
          },
          'payment_method':{
            label: 'Cash', value: 'Cash'
          },
          'remarks':'',
          'special_discount':0.00,
        },
        sales:{},
        Brands:[],
        detail:[
      {},  
      ],
      infoModal1: {
          id: 'info-modal1',
          title: '',
          content: [],
        },
      infoModal2: {
          id: 'info-modal2',
          title: '',
          content: [],
        },

      paymentmethods: [
            { label: 'Cash', value: 'Cash' },
            { label: '30 Days Credit', value: '30 Days Credit' },
            { label: '45 Days Credit', value: '45 Days Credit' },
            { label: '60 Days Credit', value: '60 Days Credit' },
            { label: 'Consignment', value: 'Consignment' },
            // Add more options as needed
        ],
        validity_periodop: [
            { label: 'Select Validity Period', value: '' },
            { label: '7 Days', value: '7 Days' },
            { label: '14 Days', value: '14 Days' },
          
           
        ],
        variants: ['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'light', 'dark','mycoolor'],
        headerBgVariant: 'mycoolor',
        headerTextVariant: 'light',
           
          }
    
        },
        components :{
          'v-select': vSelect,
            ContentFooter,
            TopNavbar,
           
        },
    

        methods : {

    
       


          async pendingProductqu(id,avlqty) {

         
       try {
         const { data} = await  axios.get('/squatation/pendingproductqu?id='+id.value,{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          
            // this.loadSquatation();
           this.qty = avlqty-data.qty;
         
            this.infoModal2.content = data.results;
            this.$root.$emit('bv::show::modal', this.infoModal2.id);
        
         
       } catch (error) {
         console.log(error.response);
       }
     },





          async pendingQuotation() {
       console.log(this.squatation.idcustomer.value);
      
          
         
       try {
         const { data} = await  axios.get('/squatation/pendingquotation?id='+this.squatation.idcustomer.value,{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          
            // this.loadSquatation();
           
            this.infoModal1.content = data.results;
            this.$root.$emit('bv::show::modal', this.infoModal1.id);
        
         
       } catch (error) {
         console.log(error.response);
       }
     },

     async Grndataload() {
       
     
       try {
         const { data} = await  axios.post('/ppurchasing/grnpodataload',{grndata:this.squatation.grndata},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          this.dtls = data.dtls;
          this.lenthdtls = this.dtls.length;
         
       } catch (error) {
         console.log(error.response);
       }
     },

     async calgrn(id) {



if(this.dtls[id].thisgrnqty==null){
this.dtls[id].thisgrnqty=0;
}
if(this.dtls[id].unitcost==null){
this.dtls[id].unitcost=0;
}

if (Number(this.dtls[id].thisgrnqty) > Number(this.dtls[id].remaining_qty)) {
  alert('Cannot exceed Remaining PO qty');
  this.dtls[id].thisgrnqty = this.dtls[id].remaining_qty;
}

const totalcostprice = (this.dtls[id].thisgrnqty * this.dtls[id].unitcost).toFixed(2);
this.$set(this.dtls[id], 'totalcostprice', totalcostprice);
let line_total_cost = 0;

if (Array.isArray(this.dtls)) {
  for (let i = 0; i < this.dtls.length; i++) {
    // Check if totalcostprice is defined (like isset in PHP)
    if ('totalcostprice' in this.dtls[i]) {
      console.log(this.dtls[i].totalcostprice);
      line_total_cost += this.dtls[i].thisgrnqty * this.dtls[i].unitcost;
    }
  }
}

this.total_cost = line_total_cost.toFixed(2);


},




          async loadPo() {
       
     
      try {
        const { data} = await  axios.get('/ppurchasing/loadpo',{
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
         this.allpo = data.allpo;
        
      } catch (error) {
        console.log(error.response);
      }
    },

    async supgrnLoad() {
       
    
       try {
         const { data} = await  axios.post('/ppurchasing/supgrnload',{G_idVendor:this.squatation.G_idVendor},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          this.allpo = data.allpo;
         
       } catch (error) {
         console.log(error.response);
       }
     },

     async loadSupplier() {
       
     
       try {
         const { data} = await  axios.get('/msupplier/supplierload2',{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          this.suppliers = data.suppliers;
         
         
         
       } catch (error) {
         console.log(error.response);
       }
     },

    
    // async loadCustomer() {
       
     
    //    try {
    //      const { data} = await  axios.get('/mcustomer/customerload',{
    //        headers:{
    //          'Authorization':'Bearer '+this.access_token,
    //          'Content-type': 'application/json',
            
    //        }
    //       });
    //       console.log(data);
    //       this.mcustomers = data.customers;
    //       this.contacts = data.contacts;
    //       this.mbrands = data.mbrands;
    //       this.mproducts = data.mproducts;
         
    //    } catch (error) {
    //      console.log(error.response);
    //    }
    //  },

   

    

     async loadPrice(id) {
       
     
       try {
         const { data} = await  axios.post('/mproduct/loadprice',{idproduct:this.detail[id].idproduct},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          this.$set(this.detail[id], 'price', data.selling_price);
          this.$set(this.detail[id], 'avlqty', data.avl);
          this.$set(this.detail[id], 'ave_cost', data.ave_cost);
          // this.sales = data.salespeoples;
          
         
       } catch (error) {
         console.log(error.response);
       }
     },

     async calculateqty(id) {
      
     if(!this.detail[id].line_discount){
      this.detail[id].line_discount = 0;
     } 
    
     if(parseFloat(this.detail[id].avlqty) < parseFloat(this.detail[id].qty)){
      alert("You are not allowed enter more than remaining qty")
      this.$set(this.detail[id], 'qty', this.detail[id].avlqty);

      
     }
  const line_amount = (this.detail[id].price * this.detail[id].qty * (100 - this.detail[id].line_discount) / 100).toFixed(2);
  this.$set(this.detail[id], 'line_amount', line_amount);

  const gpMrg = (line_amount - this.detail[id].ave_cost*this.detail[id].qty).toFixed(2);
  this.$set(this.detail[id], 'gp_margin', gpMrg);

  const gpMrgPre = (gpMrg/line_amount*100).toFixed(2);
  this.$set(this.detail[id], 'gp_margin_precentage', gpMrgPre);

  let line_amount_tot = 0;
  let gpMrg_total1 = 0;
  let gpMrgPre_total = 0;
  for (let i = 0; i <= this.count; i++) {
 line_amount_tot = line_amount_tot + this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100;

 gpMrg_total1 = gpMrg_total1 + (( this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100) - this.detail[i].ave_cost*this.detail[i].qty);

  }

  this.subtotal = line_amount_tot.toFixed(2);
  this.gpmrg_total = gpMrg_total1.toFixed(2);

  this.gpMrgPre_total = (gpMrg_total1 / line_amount_tot * 100).toFixed(2);

  const total = line_amount_tot - this.quotation.special_discount;
  this.final_total = total.toFixed(2);
  
     },

     async calculatediscount(id) {
     if(!this.detail[id].qty){
      this.detail[id].qty = 0;
     } 
  const line_amount = this.detail[id].price * this.detail[id].qty * (100 - this.detail[id].line_discount) / 100;
  this.$set(this.detail[id], 'line_amount', line_amount);

  const gpMrg = (line_amount - this.detail[id].ave_cost*this.detail[id].qty).toFixed(2);
  this.$set(this.detail[id], 'gp_margin', gpMrg);

  const gpMrgPre = (gpMrg/line_amount*100).toFixed(2);
  this.$set(this.detail[id], 'gp_margin_precentage', gpMrgPre);

  let line_amount_tot = 0;
  let gpMrg_total = 0;
  let gpMrgPre_total = 0;
  for (let i = 0; i <= this.count; i++) {
 line_amount_tot = line_amount_tot + this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100;

 gpMrg_total = gpMrg_total + (( this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100) - this.detail[i].ave_cost*this.detail[i].qty);

 
 
  }
  this.subtotal = line_amount_tot.toFixed(2);
  this.gpmrg_total = gpMrg_total.toFixed(2);
  this.gpMrgPre_total = (gpMrg_total1 / line_amount_tot * 100).toFixed(2);

  const total = line_amount_tot - this.quotation.special_discount;
  this.final_total = total.toFixed(2);

     },


     async calculatelinamt(id) {

      const discount = (100 - ((this.detail[id].line_amount*100)/(this.detail[id].price*this.detail[id].qty))).toFixed(2);
      this.$set(this.detail[id], 'line_discount', discount);

      const gpMrg = (this.detail[id].line_amount - this.detail[id].ave_cost*this.detail[id].qty).toFixed(2);
      this.$set(this.detail[id], 'gp_margin', gpMrg);

      const gpMrgPre = (gpMrg/this.detail[id].line_amount*100).toFixed(2);
      this.$set(this.detail[id], 'gp_margin_precentage', gpMrgPre);


      let line_amount_tot = 0;
      let gpMrg_total = 0;
      let gpMrgPre_total = 0;
      for (let i = 0; i <= this.count; i++) {
      line_amount_tot = line_amount_tot + this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100;

      gpMrg_total = gpMrg_total + (( this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100) - this.detail[i].ave_cost*this.detail[i].qty);

    
    
      }
      this.subtotal = line_amount_tot.toFixed(2);
      this.gpmrg_total = gpMrg_total.toFixed(2);
      this.gpMrgPre_total = (gpMrg_total / line_amount_tot * 100).toFixed(2);


      const total = line_amount_tot - this.quotation.special_discount;
      this.final_total = total.toFixed(2);



     },

     async calculategpmarg(id) {
      
       const dis = (100-((parseFloat(this.detail[id].gp_margin / this.detail[id].qty) + parseFloat(this.detail[id].ave_cost))*100/this.detail[id].price)).toFixed(2);
        this.$set(this.detail[id], 'line_discount', dis);


        const line_amount = (this.detail[id].price * this.detail[id].qty * (100 - dis) / 100).toFixed(2);
        this.$set(this.detail[id], 'line_amount', line_amount);

        const gpMrgPre = (this.detail[id].gp_margin/line_amount*100).toFixed(2);
        this.$set(this.detail[id], 'gp_margin_precentage', gpMrgPre);


      let line_amount_tot = 0;
      let gpMrg_total = 0;
      let gpMrgPre_total = 0;
      for (let i = 0; i <= this.count; i++) {
      line_amount_tot = line_amount_tot + this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100;

      gpMrg_total = gpMrg_total + (( this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100) - this.detail[i].ave_cost*this.detail[i].qty);

    
    
      }
      this.subtotal = line_amount_tot.toFixed(2);
      this.gpmrg_total = gpMrg_total.toFixed(2);
      this.gpMrgPre_total = (gpMrg_total / line_amount_tot * 100).toFixed(2);


      const total = line_amount_tot - this.quotation.special_discount;
      this.final_total = total.toFixed(2);


     },

     async calculategppre(id) {

      const dis =  (100 -(this.detail[id].ave_cost*10000/((this.detail[id].price)*(100-this.detail[id].gp_margin_precentage)))).toFixed(2);
      this.$set(this.detail[id], 'line_discount', dis);

      const line_amount = (this.detail[id].price * this.detail[id].qty * (100 - dis) / 100).toFixed(2);
        this.$set(this.detail[id], 'line_amount', line_amount);

        const gpMrg = (this.detail[id].line_amount - this.detail[id].ave_cost*this.detail[id].qty).toFixed(2);
      this.$set(this.detail[id], 'gp_margin', gpMrg);

      let line_amount_tot = 0;
      let gpMrg_total = 0;
      let gpMrgPre_total = 0;
      for (let i = 0; i <= this.count; i++) {
      line_amount_tot = line_amount_tot + this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100;

      gpMrg_total = gpMrg_total + (( this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100) - this.detail[i].ave_cost*this.detail[i].qty);

    
    
      }
      this.subtotal = line_amount_tot.toFixed(2);
      this.gpmrg_total = gpMrg_total.toFixed(2);
      this.gpMrgPre_total = (gpMrg_total / line_amount_tot * 100).toFixed(2);


      const total = line_amount_tot - this.quotation.special_discount;
      this.final_total = total.toFixed(2);



     },



     async spe_dis() {
        const total = this.subtotal - this.quotation.special_discount;
        this.final_total = total.toFixed(2);
     },

     validate(){
      this.errors = {};
      if(this.squatation.idcustomer == null){
        this.$set(this.errors, 'idCustomerError', "Customer field is required");
      }
      if(this.squatation.customer_contact == null){
        this.$set(this.errors, 'customerContactError', "Customer Contact field is required");
      }
      if(this.sales == null){
        this.$set(this.errors, 'salespeoplesError', "Sales Person field is required");
      }
      if(this.quotation.id_brand == null){
        this.$set(this.errors, 'idbrandError', "Brand field is required");
      }
     },

    async SaveQuotation() {
     
      this.validate();

      // if(Object.keys(this.errors).length === 0){
        try {
         const { data} = await  axios.post('/igrn/create',{userid:this.userid,squatation:this.squatation,dtls:this.dtls,},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
        if(data.status==200){
          this.$router.push('/cgrn/index');
        }
          
           
         
       } catch (error) {
         console.log(error.response);
       }
       //}
       
      
 
      
     },
       

        add: function(){
            this.count++;
            this.detail.push({
             
            },)
           
        },

  remove: function () {
            this.count--;
            this.detail.splice({
              
            },1)
            
        },

    },
    
    }
    
    </script>

    <style scoped>
    .button-link {
  display: inline-block;
  padding: 5px 10px;
  font-size: small;
  text-decoration: none;
  color: #3899ea;
 
 
  
  cursor: pointer;
}

.button-link:hover {
  color: black;
  text-decoration: underline;
}
      /* @import "vue-select/dist/vue-select.css"; */
/* .vs__dropdown-option--disabled {
    display: block;
} */
    </style>
    